<template>
  <div class="ProgramModuleActivity-view-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-button class="btn ml-3" type="button" @click="returnPage">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
          </span>
          Trở về trước
        </b-button>
        <b-button
          class="btn btn-inactive ml-3"
          type="button"
          v-if="programModuleActivityData.isActive && isDeletePermission"
          @click="handleInactive(programModuleActivityData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Inactive
        </b-button>
        <b-button
          class="btn btn-active ml-3"
          type="button"
          v-if="!programModuleActivityData.isActive && isDeletePermission"
          @click="handleInactive(programModuleActivityData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Active
        </b-button>
        <b-button
          class="btn btn-success ml-3"
          type="button"
          v-if="isDeletePermission"
          @click.stop="handleUpdate(programModuleActivityData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/edit-2.svg" />
          </span>
          Chỉnh sửa
        </b-button>
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="ProgramModuleActivity-view-page__body mb-6 mt-6">
        
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">Id:</div>
                    <div>
                        {{ programModuleActivityData.id }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">Code:</div>
                    <div>
                        {{ programModuleActivityData.code }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">Trạng thái xóa:</div>
                    <div>
                        {{ programModuleActivityData.isDeleted ? "Đã bị xóa" : "Chưa bị xóa" }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">CreateDatetime:</div>
                    <div>
                        {{ convertTimestampToDate(programModuleActivityData.createDatetime, "DD/MM/YYYY HH:mm:ss") }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">UpdateDatetime:</div>
                    <div>
                        {{ convertTimestampToDate(programModuleActivityData.updateDatetime, "DD/MM/YYYY HH:mm:ss") }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">CreatorId:</div>
                    <div>
                        {{ programModuleActivityData.creatorId }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">UpdaterId:</div>
                    <div>
                        {{ programModuleActivityData.updaterId }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">IsActive:</div>
                    <div>
                        {{ programModuleActivityData.isActive }}
                    </div>
            </b-col>
            <b-col>
                
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
            </b-col>
            <b-col>
                
                    <div class="text-muted">IsCustom:</div>
                    <div>
                        {{ programModuleActivityData.isCustom }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">StartAtDay:</div>
                    <div>
                        {{ programModuleActivityData.startAtDay }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">Status:</div>
                    <div>
                        {{ programModuleActivityData.status }}
                    </div>
            </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      isFirstLoad: false,
      ProgramModuleActivityData: {},
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    isDeletePermission() {
      let roles = this.currentUser?.roles;
      if (roles && roles.length) {
        return roles.includes('Admin');
      } else {
        return false;
      }
    },
  },
  methods: {
    returnPage() {
      this.$router.push({
        name: 'programModuleActivity_list',
      });
    },
    handleUpdate(item) {
      this.$router.push({
        name: 'programModuleActivity_detail',
        params: {
          form_type: 'edit',
          id: item.id,
        },
      });
    },
    handleInactive(item) {
      let text = item.isActive ? 'Inactive' : 'Active';
      let btn = item.isActive ? 'btn-inactive' : 'btn-active';
      this.$swal({
        title: '',
        text: `Bạn có chắc muốn ${text} app user ${item.id} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `${text}`,
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.inactiveItem(item)
              .then(() => {
                this.loadProgramModuleActivityData();
                this.$swal(
                  'Thành công!',
                  'Chúc mừng, bạn đã cập nhật thông tin ProgramModuleActivity thành công!',
                  'success',
                );
              })
              .catch(() => {
                this.$swal('Lỗi!', 'Đã có lỗi xảy ra.', 'error');
              });
          }
        }.bind(this),
      );
    },
    async inactiveItem(item) {
      this.loading = true;
      try {
        let payload = new FormData();
        payload.append('id', item.id);
        payload.append('active', !item.isActive);
        await this.$api.put(`ProgramModuleActivity`, payload);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    async loadProgramModuleActivityData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`ProgramModuleActivity/${id}`);
        this.programModuleActivityData = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadProgramModuleActivityData();
  },
};
</script>
